import { SourcingInternalStoreValues } from 'modules/sourcing-internal/stores/types';

export const defaultSourcingInternalStoreValues: SourcingInternalStoreValues = {
  step: 'CHOOSE_ANALYSIS',
  sessionId: null,
  initialCandidateBatchId: null,
  selectedCandidateProfiles: null,
  candidateBatch: null,
  // Campaign setup
  applicationFormData: null,
  channelFormData: null,
  jobInformationFormData: null,
  // Custom message
  isDefaultStartingTemplatedMessageLoading: false,
  defaultStartingTemplatedMessage: null,
  selectedCustomizeCandidateId: null,
  editedOpeningMessage: null,
  customizeMessageFormData: null
};
